import { DatePipe } from '@angular/common';
import { Component, HostListener, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BaseEntityComponent, BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { JanelaApuracaoTaxaMediaMaximaAgente } from 'src/app/model/janela-apuracao-taxa-media-maxima-agente';
import { Tranche } from 'src/app/model/tranche.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { JanelaApuracaoService } from 'src/app/shared/services/janela-apuracao.service';
import { TrancheService } from 'src/app/shared/services/tranche.service';

@Component({
    selector: 'app-janelas-apuracao-pesquisa',
    templateUrl: './janelas-apuracao-pesquisa.component.html',
    standalone: false
})
export class JanelasApuracaoPesquisaComponent extends BaseEntityComponent<JanelaApuracaoTaxaMediaMaximaAgente>  implements OnInit {

  //Formulario parametros
  private ideTranche: number;
  private dataInicioJanela: Date;
  private dataFimJanela: Date;
  private fechamentoRealizado: boolean;
  //private dataFimExecucao: Date;

  private atributosPaginacaoComponenteListagem: EntityPagedResult<JanelaApuracaoTaxaMediaMaximaAgente>;
  private opcoesPaginacao: number[];

  private pesquisaForm: UntypedFormGroup;

  private pesquisado: boolean;

  private tranches: Tranche[];
  private janelas: JanelaApuracaoTaxaMediaMaximaAgente[];

  private podeCadastrarJanela: boolean = false;

  constructor(
    protected injector: Injector,
    //private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private datePipe: DatePipe,
    private janelaTaxaMediaService: JanelaApuracaoService,
    private serviceTranche: TrancheService,
    private permissaoService: PermissaoService,
  ) {
    super(janelaTaxaMediaService);
    this.model = new JanelaApuracaoTaxaMediaMaximaAgente();
   }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar(false, true)
  }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
    this.pesquisado = undefined;

    this.serviceTranche.getTranches().subscribe(tranches => {
      this.tranches = tranches;
    });
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeCadastrarJanela = resp && resp[ROLE_GESTOR_ENVIO];
    });

    this.construirformulario();
  }

  construirformulario(){
    this.pesquisaForm = this.formBuilder.group(
      {
        ideTranche: [null],
        dataInicioJanela: [null,[]],
        dataFimJanela: [null,[]],
        fechamentoRealizado: [null]
      }
    );

  }

  getParams(){
    const params: any = {};
    this.ideTranche = this.pesquisaForm.get("ideTranche").value;
    this.dataInicioJanela = this.pesquisaForm.get("dataInicioJanela").value;
    this.dataFimJanela = this.pesquisaForm.get("dataFimJanela").value;
    this.fechamentoRealizado = this.pesquisaForm.get("fechamentoRealizado").value;


    if(this.ideTranche) params.ideTranche = this.ideTranche;
    if(this.dataInicioJanela) params.dataInicioJanela = this.datePipe.transform(this.dataInicioJanela, 'yyyyMMdd');
    if(this.dataFimJanela) params.dataFimJanela = this.datePipe.transform(this.dataFimJanela, 'yyyyMMdd');;
    if(this.fechamentoRealizado != null) params.fechamentoRealizado = this.fechamentoRealizado;

    return params;
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean){
    this.loadingService.bloqueiaTela();
    this.pesquisado = false;
    const params: any = this.getParams();

    this.janelaTaxaMediaService.buscarJanelasApuracao(params).subscribe(janelas => {
      this.janelas = janelas ? janelas : null;
      this.pesquisado = true;
      this.loadingService.liberaTela();
    });

  }

  limpar() : void{
    this.ideTranche = undefined;
    this.dataFimJanela = undefined;
    this.dataInicioJanela = undefined;
    this.fechamentoRealizado = undefined;

    this.pesquisado = undefined;

    this.pesquisaForm.reset();
    this.pesquisaForm.get('dataFimJanela').reset();
    this.pesquisaForm.get('ideTranche').reset();
    this.pesquisaForm.get('dataInicioJanela').reset();
    this.pesquisaForm.get('fechamentoRealizado').reset();
    this.pesquisaForm.updateValueAndValidity();

  }

}
